<era-room-status-dropdown [isCheckedIn]="roomIsCheckedIn()"
                          (checkInStateChanged)="updateRoomCheckInState($event)">
  <span checkedin>Checked in</span>
  <span checkedout>Checked out</span>
  <span checkin>Check in</span>
  <span checkout>Check out</span>
</era-room-status-dropdown>